import classNames from 'classnames';
import React from 'react';
import { Scrollbars } from '@meitu/saas-ui';
import { BackTitle } from '@meitu/saas-ui/es/title';
import './style.less';

type Props = React.ComponentProps<'div'> & {
    title: string;
    onExit: () => void;
};

export const SubPanelContainer: React.FC<Props> = ({ title, onExit, children, style = {}, className }) => {
    return (
        <div className={classNames('sub-panel-container', className)} style={style}>
            <div className="sub-panel-container__header">
                <BackTitle text={title} handleBackClick={onExit} />
            </div>

            <Scrollbars autoHide>
                <div className="sub-panel-container__body">{children}</div>
            </Scrollbars>
        </div>
    );
};
